import React, {FormEvent, useCallback, useEffect, useState} from "react";
import {MessageDisplay, MessageState} from "../components/Message";
import {authRegister, authRegisterErrors, UserRegisterInfo} from "./AuthenticationService";
import {AxiosError, AxiosResponse} from "axios";
import {ErrorObject, getError, isLoggedIn, setToken} from "../api/apiConfig";
import {Card, Form} from "react-bootstrap";
import {CheckAll, GlobeAmericas, KeyFill} from "react-bootstrap-icons";
import InputControlled from "../components/InputControlled";
import {Link, useNavigate} from "react-router-dom";
import PasswordStrengthBar from "react-password-strength-bar";
import {ButtonFancy} from "../basic/ButtonFancy";

export interface RegisterErrorState {
    username?: boolean;
    email?: boolean;
    password?: boolean;
    password2?: boolean;
}

export const registerInputClass = (value?: boolean): string => {
    if(value === undefined) return "";
    return value ? "is-valid" : "is-invalid";
}

export default function RegisterPage() {
    const [submitting, submittingSet] = useState(false);
    const [errors, errorsSet] = useState<RegisterErrorState>({email: undefined, password: undefined, password2: undefined});
    const [message, messageSet] = useState<MessageState>();
    const [registerInfo, registerInfoSet] = useState<UserRegisterInfo>({username: "", email: "", password: "", password2: ""});

    const navigate = useNavigate();
    const onRegister = useCallback((event: FormEvent) => {
        event.preventDefault();
        if(!registerInfo) return;

        submittingSet(true);
        messageSet(undefined);
        authRegister(registerInfo).then((response: AxiosResponse<string>) => {
            //messageSet({type: "success", message: "Du wurdest erfolgreich registriert."});
            setToken(response.data);
            navigate("/app");
        }, (error: AxiosError<ErrorObject>) => {
            messageSet({type: "danger", message: getError(error.response?.data, authRegisterErrors)});
        }).finally(() => submittingSet(false));
    }, [navigate, registerInfo]);

    useEffect(() => {
        if(isLoggedIn()) {
            navigate("/app");
        }
    }, [navigate])

    return (
        <div className="container d-flex align-items-center justify-content-center" style={{height: "100vh"}}>
            <Card style={{maxWidth: "600px"}} className="w-100 bg-fancy">
                <Form onSubmit={onRegister} autoComplete="off" className="bg-fancy-offset">
                    <Card.Body>
                        <MessageDisplay message={message}/>
                        <Card.Title className="text-center fw-bold">Register</Card.Title>
                        <Form.Group className="mb-3">
                            <Form.Label className="text-left">Username</Form.Label>
                            <InputControlled type="text" name="name" value={registerInfo.username} className={"form-control " + registerInputClass(errors.username)} handleChange={(v: string) => {
                                const x = {...registerInfo};
                                x.username = v;
                                registerInfoSet(x);
                                const er = {...errors};
                                er.username = x.username.length>=6;
                                errorsSet(er);
                            }}/>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="text-left"><GlobeAmericas /> Email Address</Form.Label>
                            <InputControlled type="email" name="email" autoComplete="email" value={registerInfo.email} className={"form-control " + registerInputClass(errors.email)} handleChange={(v: string) => {
                                const x = {...registerInfo};
                                x.email = v;
                                registerInfoSet(x);
                                const er = {...errors};
                                er.email = x.email.indexOf("@") !== -1;
                                errorsSet(er);
                            }}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label><KeyFill /> Password</Form.Label>
                            <InputControlled type="password" name="password" value={registerInfo.password} className={"form-control " + registerInputClass(errors.password)} handleChange={(v: string) => {
                                const x = {...registerInfo};
                                x.password = v;
                                registerInfoSet(x);
                                const er = {...errors};
                                er.password = x.password.length >= 6;
                                errorsSet(er);
                            }}/>
                            <PasswordStrengthBar className="px-2" minLength={6} password={registerInfo.password} scoreWords={['Weak', 'Weak', 'Good', 'Strong', 'Very Strong']} shortScoreWord="Too Short" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label><CheckAll /> Repeat Password</Form.Label>
                            <InputControlled type="password" name="password-repeat" value={registerInfo.password2} className={"form-control " + registerInputClass(errors.password2)} handleChange={(v: string) => {
                                const x = {...registerInfo};
                                x.password2 = v;
                                registerInfoSet(x);
                                const er = {...errors};
                                er.password2 = registerInfo.password === x.password2;
                                errorsSet(er);
                            }}/>
                        </Form.Group>
                    </Card.Body>
                    <Card.Footer>
                    <div className='d-flex py-2 flex-column align-items-center'>
                        <ButtonFancy type="submit" disabled={submitting
                            || registerInfo.email.indexOf("@") === -1
                            || registerInfo.password !== registerInfo.password2
                            || registerInfo.password.length < 6}>
                            Register
                        </ButtonFancy>
                        </div>
                        <div className="d-flex py-2 flex-column align-items-center small">
                            <p className='text-muted mb-0'>Already have an Account?</p>
                            <Link to="/app/login" className='text-link'>Login</Link>
                        </div>
                    </Card.Footer>
                </Form>
            </Card>
        </div>);
};